import {VECTOR3} from '../../index.js';

/**
 * Creates Hypercube.js skyboxes.
 * @example
 * const skybox = new Skybox(name, color);
 */
class Skybox {

    /**
     * Stores the color.
     * @type {vector3}
     * @protected
     */
    $color;

    /**
     * Stores the name.
     * @type {string}
     * @private
     */
    $name;

    /**
     * Gets the color.
     * @type {vector3}
     * @public
     * @readonly
     */
    get color() {

        return this.$color;
    };

    /**
     * Gets the name.
     * @type {string}
     * @public
     * @readonly
     */
    get name() {

        return this.$name;
    }

    /**
     * Creates a new Hypercube.js skybox.
     * @param {string} $name The name of the skybox.
     * @param {vector3} $color The color of the skybox.
     */
    constructor($name, $color) {

        this.$name = $name;
        this.$color = VECTOR3.clone($color);
    }
}

export {

    Skybox
};

export default Skybox;
